import { graphql } from "react-relay"
import { useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { useUpdateConsultationReportMutation as useUpdateConsultationReportMutationType } from "@/modules/patients/detail/consultation-report/services/__generated__/useUpdateConsultationReportMutation.graphql"

const updateConsultationReportMutation = graphql`
  mutation useUpdateConsultationReportMutation($input: Ch_updateConsultationReportInput!) {
    ch_updateConsultationReport(input: $input) {
      ch_ConsultationReport {
        id
        progressNoteId
        patientId
        createdAt
        createdBy
        updatedAt
        updatedBy
        fileId
        signedAt
        concludedAt
        concludedBy
        language
        healthcareProviderId
        diagnosisCode
        anamnesis
        recommendedTreatment
        isAiGenerated
        isAiContentModified
        fileMetadata {
          documentType
          extension
          lengthInKilobytes
        }
      }
      errors {
        ... on DocumentDoesNotExist {
          message
        }
        ... on FieldLengthInvalid {
          message
        }
        ... on ConsultationReportCareProviderNotFound {
          message
        }
      }
    }
  }
`

const useUpdateConsultationReportMutation = () => {
  return useMutationWithErrorDialog<useUpdateConsultationReportMutationType>(updateConsultationReportMutation)
}

export { useUpdateConsultationReportMutation }
